import api from '@/libs/axiosInstance';
import type { ApiResponse, GoogleDriveHealthStatus } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export interface DriveStatus {
  isConnected: boolean;
  connectedByEmail?: string;
  driveRootFolderId?: string | null;
  lastHealthStatus?: GoogleDriveHealthStatus;
  lastHealthCheckAt?: string | null;
  connectedAt?: string;
  workspaceDomain?: string | null;
}

const fetchDriveStatus = async (): Promise<DriveStatus> => {
  const response = await api.get<ApiResponse<DriveStatus>>(
    '/dashboard/integrations/google-drive/status'
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || 'Failed to fetch Google Drive status');
};

export const useDriveStatusQuery = (enabled: boolean = true) => {
  return useQuery<DriveStatus, Error>({
    queryKey: ['drive', 'status'],
    queryFn: fetchDriveStatus,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};
